// @flow

import React from "react";

export default props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "24.414"}
    height={props.height || "15.557"}
    viewBox="0 0 24.414 15.557"
  >
    <path
      d="M6255.584-14750.192l-6.362-6.362,1.413-1.417,5.365,5.365v-20.584h2v20.587l5.365-5.368,1.416,1.417-6.366,6.362-1.413,1.416Z"
      transform="translate(14773.19 6264.779) rotate(-90)"
      fill="currentColor"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/SideArrow.js